import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { isFeatureEnabled } from 'owa-feature-flags';

export default action('onNewsWhatsNewClicked', () =>
    addDatapointConfig({
        name: 'NewsWhatsNewClicked',
        customData: {
            view: isFeatureEnabled('tri-newsCompact') ? 'Compact' : 'Regular',
        },
    })
);
